export const trackersFacebookPixel = {
  loaded: false,
  enabled: false,

  // Load Facebook Pixel and begin tracking.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!
  load: function(facebookPixelId) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Facebook Pixel");

      // See https://developers.facebook.com/docs/facebook-pixel/implementation
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq)f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));

      fbq('consent', 'grant');
      fbq('init', facebookPixelId);
      fbq('track', 'PageView');

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Facebook Pixel scripts already loaded - re-enabling");
      fbq('consent', 'grant');
      this.enabled = true;
    }
  },

  // Revoke consent for this user to be tracked by Facebook Pixel
  // See https://developers.facebook.com/docs/facebook-pixel/implementation/gdpr/
  revokeConsent: function() {
    if (!this.loaded) {
      console.log("Disabling Facebook Pixel - scripts not loaded yet anyway");
      this.enabled = false;
    } else {
      console.log("Disabling Facebook Pixel");
      fbq('consent', 'revoke');
      this.enabled = false;
    }
  }
};
